// sliders
$(function () {
  $('.client-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    sautoplaySpeed: 4000,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          sautoplaySpeed: 4000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          sautoplaySpeed: 4000,
        },
      },
    ],
  })

  $('.sectors-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    dots: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3.2,
          arrows: true,
          autoplay: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.1,
          arrows: false,
          autoplay: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2.2,
          arrows: false,
          autoplay: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          arrows: false,
          autoplay: true,
        },
      },
    ],
  })

  $('.hero-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    dots: false,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          autoplay: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          arrows: true,
          autoplay: true,
        },
      },
    ],
  })

  $('.deals-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    dots: false,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          autoplay: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          arrows: true,
          autoplay: true,
        },
      },
    ],
  })

  $('.reviews-slider,.team__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    dots: false,
  })
})
$(function () {
  function setEqualMinHeight(selector) {
    const $items = $(selector)
    let maxHeight = 0

    $items.css('min-height', '')

    $items.each(function () {
      const height = $(this).outerHeight()
      if (height > maxHeight) maxHeight = height
    })

    $items.css('min-height', maxHeight)
  }

  function recalcAll() {
    setEqualMinHeight('.hero-slider__content:not(.gated-download-hero__content)')
  }

  recalcAll()
  $(window).on('resize', recalcAll)
})
$(function () {
  $('.burger-menu').on('click', function (e) {
    e.preventDefault()
    $('body').toggleClass('nav-active')
  })
  $("#header nav a[href^='#']").on('click', function () {
    $('body').removeClass('nav-active')
  })

  // two level menu
  $(function () {
    function isMobile() {
      return window.innerWidth <= 1024
    }

    function openOnly($item) {
      $('.menu-item-has-children').not($item).removeClass('menu-item--hover')
      $item.addClass('menu-item--hover')
    }

    $(document)
      .on('mouseenter', '.menu-item-has-children', function () {
        if (!isMobile()) $(this).addClass('menu-item--hover')
      })
      .on('mouseleave', '.menu-item-has-children', function () {
        if (!isMobile()) $(this).removeClass('menu-item--hover')
      })

    $(document).on('click', '.menu-item-has-children > .menu-item__link', function (e) {
      if (!isMobile()) return

      var $link = $(this)
      var $parent = $link.closest('.menu-item-has-children')
      var href = $link.attr('href')

      if (!$parent.hasClass('menu-item--hover')) {
        e.preventDefault()
        openOnly($parent)
        return
      }

      if (!href || href === '#') {
        e.preventDefault()
        $parent.removeClass('menu-item--hover')
      }
    })

    $(document).on('click', '.menu-item-has-children .sub-menu a', function () {
      $('.menu-item-has-children').removeClass('menu-item--hover')
    })

    $(document).on('click touchstart pointerdown', function (e) {
      if ($(e.target).closest('.menu-item-has-children').length === 0) {
        $('.menu-item-has-children').removeClass('menu-item--hover')
      }
    })
  })
})
// scroll for header background
$(function () {
  var header = $('body')
  $(window).scroll(function () {
    var scroll = $(window).scrollTop()

    if (scroll > 40) {
      header.addClass('scroll')
    } else {
      header.removeClass('scroll')
    }
  })
})
jQuery(function () {
  initAnchors()
})

// initialize smooth anchor link
function initAnchors() {
  const anchorOffset = parseInt(getComputedStyle(document.body).getPropertyValue('--offset-height'))

  new SmoothScroll({
    anchorLinks: 'a[href^="#"]:not([href="#"])',
    extraOffset: anchorOffset || 70,
    wheelBehavior: 'none',
  })
}
/*!
 * SmoothScroll module
 */
;(function ($, exports) {
  var page,
    win = $(window),
    activeBlock,
    activeWheelHandler,
    wheelEvents =
      'onwheel' in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll'

  function scrollTo(offset, options, callback) {
    var scrollBlock
    if (document.body) {
      if (typeof options === 'number') {
        options = {
          duration: options,
        }
      } else {
        options = options || {}
      }
      page = page || $('html, body')
      scrollBlock = options.container || page
    } else {
      return
    }

    if (typeof offset === 'number') {
      offset = {
        top: offset,
      }
    }

    if (activeBlock && activeWheelHandler) {
      activeBlock.off(wheelEvents, activeWheelHandler)
    }
    if (options.wheelBehavior && options.wheelBehavior !== 'none') {
      activeWheelHandler = function (e) {
        if (options.wheelBehavior === 'stop') {
          scrollBlock.off(wheelEvents, activeWheelHandler)
          scrollBlock.stop()
        } else if (options.wheelBehavior === 'ignore') {
          e.preventDefault()
        }
      }
      activeBlock = scrollBlock.on(wheelEvents, activeWheelHandler)
    }

    scrollBlock.stop().animate(
      {
        scrollLeft: offset.left,
        scrollTop: offset.top,
      },
      options.duration,
      function () {
        if (activeWheelHandler) {
          scrollBlock.off(wheelEvents, activeWheelHandler)
        }
        if ($.isFunction(callback)) {
          callback()
        }
      },
    )
  }

  function SmoothScroll(options) {
    this.options = $.extend(
      {
        anchorLinks: 'a[href^="#"]',
        container: null,
        extraOffset: null,
        activeClasses: null,
        easing: 'swing',
        animMode: 'duration',
        animDuration: 800,
        animSpeed: 1500,
        anchorActiveClass: 'anchor-active',
        sectionActiveClass: 'section-active',
        wheelBehavior: 'stop',
        useNativeAnchorScrolling: false,
      },
      options,
    )
    this.init()
  }
  SmoothScroll.prototype = {
    init: function () {
      this.initStructure()
      this.attachEvents()
      this.isInit = true
    },
    initStructure: function () {
      var self = this

      this.container = this.options.container ? $(this.options.container) : $('html,body')
      this.scrollContainer = this.options.container ? this.container : win
      this.anchorLinks = jQuery(this.options.anchorLinks).filter(function () {
        return jQuery(self.getAnchorTarget(jQuery(this))).length
      })
    },
    getId: function (str) {
      try {
        return '#' + str.replace(/^.*?(#|$)/, '')
      } catch (err) {
        return null
      }
    },
    getAnchorTarget: function (link) {
      var targetId = this.getId($(link).attr('href'))
      return $(targetId.length > 1 ? targetId : 'html')
    },
    getTargetOffset: function (block) {
      var blockOffset = block.offset().top
      if (this.options.container) {
        blockOffset -= this.container.offset().top - this.container.prop('scrollTop')
      }

      if (typeof this.options.extraOffset === 'number') {
        blockOffset -= this.options.extraOffset
      } else if (typeof this.options.extraOffset === 'function') {
        blockOffset -= this.options.extraOffset(block)
      }
      return {
        top: blockOffset,
      }
    },
    attachEvents: function () {
      var self = this

      if (this.options.activeClasses && this.anchorLinks.length) {
        this.anchorData = []

        for (var i = 0; i < this.anchorLinks.length; i++) {
          var link = jQuery(this.anchorLinks[i]),
            targetBlock = self.getAnchorTarget(link),
            anchorDataItem = null

          $.each(self.anchorData, function (index, item) {
            if (item.block[0] === targetBlock[0]) {
              anchorDataItem = item
            }
          })

          if (anchorDataItem) {
            anchorDataItem.link = anchorDataItem.link.add(link)
          } else {
            self.anchorData.push({
              link: link,
              block: targetBlock,
            })
          }
        }

        this.resizeHandler = function () {
          if (!self.isInit) return
          self.recalculateOffsets()
        }
        this.scrollHandler = function () {
          self.refreshActiveClass()
        }

        this.recalculateOffsets()
        this.scrollContainer.on('scroll', this.scrollHandler)
        win.on('resize load orientationchange refreshAnchor', this.resizeHandler)
      }

      this.clickHandler = function (e) {
        self.onClick(e)
      }
      if (!this.options.useNativeAnchorScrolling) {
        this.anchorLinks.on('click', this.clickHandler)
      }
    },
    recalculateOffsets: function () {
      var self = this
      $.each(this.anchorData, function (index, data) {
        data.offset = self.getTargetOffset(data.block)
        data.height = data.block.outerHeight()
      })
      this.refreshActiveClass()
    },
    toggleActiveClass: function (anchor, block, state) {
      anchor.toggleClass(this.options.anchorActiveClass, state)
      block.toggleClass(this.options.sectionActiveClass, state)
    },
    refreshActiveClass: function () {
      var self = this,
        foundFlag = false,
        containerHeight = this.container.prop('scrollHeight'),
        viewPortHeight = this.scrollContainer.height(),
        scrollTop = this.options.container ? this.container.prop('scrollTop') : win.scrollTop()

      if (this.options.customScrollHandler) {
        this.options.customScrollHandler.call(this, scrollTop, this.anchorData)
        return
      }

      this.anchorData.sort(function (a, b) {
        return a.offset.top - b.offset.top
      })

      $.each(this.anchorData, function (index) {
        var reverseIndex = self.anchorData.length - index - 1,
          data = self.anchorData[reverseIndex],
          anchorElement = self.options.activeClasses === 'parent' ? data.link.parent() : data.link

        if (scrollTop >= containerHeight - viewPortHeight) {
          if (reverseIndex === self.anchorData.length - 1) {
            self.toggleActiveClass(anchorElement, data.block, true)
          } else {
            self.toggleActiveClass(anchorElement, data.block, false)
          }
        } else {
          if (!foundFlag && (scrollTop >= data.offset.top - 1 || reverseIndex === 0)) {
            foundFlag = true
            self.toggleActiveClass(anchorElement, data.block, true)
          } else {
            self.toggleActiveClass(anchorElement, data.block, false)
          }
        }
      })
    },
    calculateScrollDuration: function (offset) {
      var distance
      if (this.options.animMode === 'speed') {
        distance = Math.abs(this.scrollContainer.scrollTop() - offset.top)
        return (distance / this.options.animSpeed) * 1000
      } else {
        return this.options.animDuration
      }
    },
    onClick: function (e) {
      var targetBlock = this.getAnchorTarget(e.currentTarget),
        targetOffset = this.getTargetOffset(targetBlock)

      e.preventDefault()
      scrollTo(targetOffset, {
        container: this.container,
        wheelBehavior: this.options.wheelBehavior,
        duration: this.calculateScrollDuration(targetOffset),
      })
      this.makeCallback('onBeforeScroll', e.currentTarget)
    },
    makeCallback: function (name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments)
        args.shift()
        this.options[name].apply(this, args)
      }
    },
    destroy: function () {
      var self = this

      this.isInit = false
      if (this.options.activeClasses) {
        win.off('resize load orientationchange refreshAnchor', this.resizeHandler)
        this.scrollContainer.off('scroll', this.scrollHandler)
        $.each(this.anchorData, function (index) {
          var reverseIndex = self.anchorData.length - index - 1,
            data = self.anchorData[reverseIndex],
            anchorElement = self.options.activeClasses === 'parent' ? data.link.parent() : data.link

          self.toggleActiveClass(anchorElement, data.block, false)
        })
      }
      this.anchorLinks.off('click', this.clickHandler)
    },
  }

  // public API
  $.extend(SmoothScroll, {
    scrollTo: function (blockOrOffset, durationOrOptions, callback) {
      scrollTo(blockOrOffset, durationOrOptions, callback)
    },
  })

  // export module
  exports.SmoothScroll = SmoothScroll
})(jQuery, this)
// Play and Pause button

$(function () {
  const videoPlayer = document.querySelector('.video-box')

  if (!videoPlayer) {
    return
  }

  const video = videoPlayer.querySelector('.video')
  const playButton = videoPlayer.querySelector('.play-button')

  $(playButton).on('click', function () {
    if (video.paused) {
      video.play()
      $(this).addClass('active')
    } else {
      video.pause()
      $(this).removeClass('active')
    }
  })
})
document.addEventListener('DOMContentLoaded', () => {
  const initObserver = (section) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add('deals-statistic--visible')
          } else {
            section.classList.remove('deals-statistic--visible')
          }
        })
      },
      { threshold: 0.3 },
    )

    observer.observe(section)
  }

  let section = document.querySelector('.deals-statistic')
  if (section) {
    initObserver(section)
    return
  }

  const mutationObserver = new MutationObserver(() => {
    section = document.querySelector('.deals-statistic')
    if (section) {
      initObserver(section)
      mutationObserver.disconnect()
    }
  })

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })
})
$(function () {
  //custom select
  $('select-option_selected').on('click', function () {
    $(this).parents('.custom-select ').toggleClass('select-active')
  })

  $('.select-option_selected').on('click', function (e) {
    e.preventDefault()
    $(this).closest('.custom-select').toggleClass('select_open')
  })

  //inputs disabled with labels
  function syncDisabledToLabel() {
    $('input[id], textarea[id]').each(function () {
      const $input = $(this)
      const $label = $('label[for="' + this.id + '"]')

      if ($input.is(':disabled') || $input.hasClass('disabled')) {
        $label.addClass('disabled')
      } else {
        $label.removeClass('disabled')
      }
    })
  }
})
jQuery(function ($) {
  const debounce = function (fn, time = 300) {
    let timeout

    return function () {
      const self = this
      const args = arguments

      clearTimeout(timeout)
      timeout = setTimeout(function () {
        fn.apply(self, args)
      }, time)
    }
  }

  const highlightQuery = function (text, query) {
    if (!query) return text

    const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

    return text.replace(new RegExp(escaped, 'gi'), function (match) {
      return `<mark>${match}</mark>`
    })
  }

  const escapeHtml = function (value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
      }[char]
    })
  }

  const getSearchPayload = function ($form, keyword) {
    return {
      action: 'cognos_ajax_search_cards',
      nonce: COGNOS_CARDS_SEARCH.nonce,
      keyword,
      context: $form.data('context') || '',
      service: $form.find('input[name="service"]').val() || '',
      industry: $form.find('input[name="industry"]').val() || '',
      news_category: $form.find('input[name="news_category"]').val() || '',
    }
  }

  const removeResults = function ($form) {
    $form.find('.search-result_list').remove()
  }

  const renderResults = function ($form, items, keyword) {
    removeResults($form)

    if (!items.length) {
      $form
        .find('.search-input')
        .after(
          '<div class="search-result_list mCustomScrollbar">' +
            '<div class="search-result_list-item search-result_list-item-no-result">No items found</div>' +
            '</div>',
        )
      return
    }

    const itemsMarkup = items
      .map(function (item) {
        const title = escapeHtml(item.title || '')
        const url = escapeHtml(item.url || '#')
        const highlightedTitle = highlightQuery(title, keyword)

        return (
          '<div class="search-result_list-item">' +
          `<a href="${url}">${highlightedTitle}</a>` +
          '</div>'
        )
      })
      .join('')

    $form
      .find('.search-input')
      .after(`<div class="search-result_list mCustomScrollbar">${itemsMarkup}</div>`)
  }

  const toggleClearButton = function ($form) {
    const hasValue = $.trim($form.find('.search-input').val()).length > 0
    $form.find('.search-button_clear').prop('hidden', !hasValue)
  }

  function initSearchAutocomplete() {
    $('.search-form').each(function () {
      const $form = $(this)
      const $input = $form.find('.search-input')

      if (!$input.length || $form.data('search-initialized')) {
        return
      }

      $form.data('search-initialized', true)
      toggleClearButton($form)

      $input.on(
        'input',
        debounce(async function () {
          const $currentForm = $(this).closest('.search-form')
          const inputValue = $.trim($(this).val()).toLowerCase()

          removeResults($currentForm)
          toggleClearButton($currentForm)

          if (inputValue.length <= 1) {
            return
          }

          try {
            const response = await $.post(
              COGNOS_CARDS_SEARCH.ajaxUrl,
              getSearchPayload($currentForm, inputValue),
            )

            const items =
              response && response.success && Array.isArray(response.data) ? response.data : []

            renderResults($currentForm, items, inputValue)
          } catch (error) {
            console.error('Search ajax error', error)
            renderResults($currentForm, [], inputValue)
          }
        }, 300),
      )

      $form.on('submit', function () {
        removeResults($form)
      })

      $form.find('.search-button_clear').on('click', function (event) {
        event.preventDefault()

        const url = new URL(window.location.href)

        $input.val('')
        removeResults($form)
        toggleClearButton($form)

        if (url.searchParams.has('keyword')) {
          url.searchParams.delete('keyword')
          window.location.href = url.toString()
        }
      })
    })

    $(document).on('click', function (event) {
      if (!$(event.target).closest('.search-form').length) {
        $('.search-result_list').remove()
      }
    })
  }

  $(window).on('load', function () {
    initSearchAutocomplete()
  })
})
// Toggle hidden text in sectors-item on opener click
document.addEventListener('DOMContentLoaded', () => {
  const openers = document.querySelectorAll('.sectors-item__title .opener');

  openers.forEach((opener) => {
    const toggleHiddenText = () => {
      const sectorsItem = opener.closest('.sectors-item');
      const hiddenText = sectorsItem.querySelector('.sectors-item__hidden-text');

      if (hiddenText) {
        const isOpen = opener.classList.toggle('open');
        hiddenText.classList.toggle('open', isOpen);
        opener.setAttribute('aria-expanded', String(isOpen));
      }
    };

    opener.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      toggleHiddenText();
    });

    opener.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleHiddenText();
      }
    });
  });
});

// add class to buttons with inline background
document.querySelectorAll('a.btn').forEach((el) => {
  if (el.style.background) {
    el.classList.add('has-inline-bg')
  }
})